<div class="flex items-center w-fit h-screen m-auto">
  <p>{{ 'onboard:redirectAuth0' | translate }}</p>
</div>
